<template>
	<v-row justify="center" no-gutters>
		<v-col cols="10">
			<v-card
				rounded
				outlined
				background-color="transparent"
				border-color="black"
			>
				<v-overlay :value="isLoading" absolute style="min-height: 100px">
					<v-progress-circular
						indeterminate
						color="secondary"
						v-show="isLoading"
					/>
				</v-overlay>

				<v-fade-transition>
					<v-list
						color="transparent"
						flat
						dense
						class="text-left"
						v-if="!isLoading"
						style="min-height: 300px"
					>
						<v-list-item-group v-model="activeGroups" multiple>
							<v-list-item
								v-for="{ GroupName, Description } in availableGroups"
								:key="GroupName"
								:value="GroupName"
								@click="handleClick(GroupName)"
							>
								<template v-slot:default="{ active }">
									<v-list-item-action>
										<v-checkbox :input-value="active" />
									</v-list-item-action>

									<v-list-item-content>
										<v-list-item-title v-text="GroupName" />
										<v-list-item-subtitle v-text="Description" />
									</v-list-item-content>
								</template>
							</v-list-item>
						</v-list-item-group>
					</v-list>
				</v-fade-transition>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'UserGroups',

	props: {
		groups: Array,
		availableGroups: Array,
		isLoading: Boolean,
	},

	data() {
		return {
			activeGroups: [],
		}
	},

	watch: {
		// Update active group list, when parent object is changed
		groups: function (newGroups) {
			this.setActiveGroups(newGroups)
		},
	},

	methods: {
		setActiveGroups(groups) {
			this.activeGroups = [...groups.map((g) => g.GroupName)]
		},
		handleClick(group) {
			// Check if item is added or removed
			const insert = !this.activeGroups.includes(group)
			const action = insert ? 'add-to-group' : 'remove-from-group'
			this.$emit(action, group)
		},
	},
}
</script>

<style lang="scss" scoped>
</style>